var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstalment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27156",
    "data-name": "Group 27156",
    transform: "translate(-89 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37796",
    "data-name": "Path 37796",
    d: "M-3.239-9.279c.029-.682.8-.954,1.549-.954C-.9-10.2-.317-9.961-.317-9.211c0,.789-.945.945-1.461.945-1.344,0-2.766.467-2.766,2.036v1.792H.978v-1.2H-3.258v-.584c0-.74.915-.886,1.48-.886,1.432,0,2.737-.4,2.737-2.133,0-1.6-1.373-2.1-2.649-2.1-1.305,0-2.7.458-2.824,2.065Z",
    transform: "translate(104.501 50.692)",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27153",
    "data-name": "Group 27153",
    transform: "translate(89 29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    d: "M14,2.1A11.9,11.9,0,0,0,5.585,22.415,11.9,11.9,0,0,0,22.415,5.585,11.822,11.822,0,0,0,14,2.1M14,0A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
    transform: "translate(0)",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalment2);
export default __webpack_public_path__ + "static/media/instalment-2.82474b43cde750e36c90195183aee2eb.svg";
export { ForwardRef as ReactComponent };